const stagingConfig = {
  9878: {
    iframeUrl: '/appointment-booking-assets/appointment-booking.html',
    questions: {
      '6814a728-60bb-11e7-bbea-02e4563f24a3': ['65+'],
      '7aab1d47-0155-11e6-9ebe-22000b0a2127': 'yes',
    },
  },
  9953: {
    /**
     * The ES appointment booking iframe
     */
    iframeUrl: '/appointment-booking-assets/spain/appointment-booking.html',
    questions: {
      '6f74be29-2a93-11e7-a693-02e4563f24a3': [
        '56 a 65 años',
        'Mayor de 65 años',
      ],
    },
  },
  9911: {
    iframeUrl: '/appointment-booking-assets/appointment-booking.html',
    questions: {
      'e54aadc9-16a3-11ef-a18b-0248b00e5bcd': 'yes',
    },
  },
};

const testConfig = {
  ...stagingConfig,
  1234: {
    iframeUrl: '/appointment-booking-assets/appointment-booking.html',
  },
};

const appointmentBookingConfig = {
  development: stagingConfig,
  staging: stagingConfig,
  test: testConfig,
  'production-eu': {
    15098: {
      iframeUrl: '/appointment-booking-assets/appointment-booking.html',
      questions: {
        'dda4adbf-1b4e-11e6-9ebe-22000b0a2127': 'Über 65', // i.e. over 65
        '7faa9715-153f-11eb-a002-020dd6cd03c5': 'Ja', // would like to book
      },
    },
    15182: {
      iframeUrl: '/appointment-booking-assets/appointment-booking.html',
      questions: {
        'e54aadc9-16a3-11ef-a18b-0248b00e5bcd': 'yes',
      },
    },
    15490: {
      /**
       * A ES Prod AB Form with live traffic
       */
      iframeUrl: '/appointment-booking-assets/spain/appointment-booking.html',
      questions: {
        '6f74be29-2a93-11e7-a693-02e4563f24a3': [
          '56 a 65 años',
          'Mayor de 65 años',
        ],
      },
    },
    15348: {
      /**
       * The ES appointment booking test / prod form
       */
      iframeUrl: '/appointment-booking-assets/spain/appointment-booking.html',
      questions: {},
    },
  },
  'production-na': {
    6833: {
      iframeUrl: '/appointment-booking-assets/appointment-booking.html',
      questions: {
        '6814a728-60bb-11e7-bbea-02e4563f24a3': 'no', // i.e. over 65
        'ce29f4eb-60bc-11e7-bbea-02e4563f24a3': 'yes',
      },
    },
  },
};

export default appointmentBookingConfig;
